module.exports = __webpack_public_path__ + "img/img4.0fdf3886.png";